"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Background = _interopRequireDefault(require("./Background"));
var _microSlider = _interopRequireDefault(require("micro-slider"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CarouselCell = /*#__PURE__*/function (_react$default$PureCo) {
  function CarouselCell() {
    _classCallCheck(this, CarouselCell);
    return _callSuper(this, CarouselCell, arguments);
  }
  _inherits(CarouselCell, _react$default$PureCo);
  return _createClass(CarouselCell, [{
    key: "attachSlider",
    value: function attachSlider() {
      var cell = this.props.cell;
      var options = _objectSpread(_objectSpread({
        indicators: true,
        indicatorText: '',
        padding: cell.padding,
        arrows: cell.arrows
      }, !!cell.arrows_inner_color ? {
        arrowsInnerColor: cell.arrows_inner_color
      } : {}), !!cell.arrows_outer_color ? {
        arrowsOuterColor: cell.arrows_outer_color
      } : {});
      this.slider = new _microSlider.default("#slider_".concat(cell.id), options);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.attachSlider();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!!this.slider) {
        this.slider.detach();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (!!prevProps.intl && !!this.props.intl && this.props.intl.locale !== prevProps.intl.locale || !prevProps.intl && !!this.props.intl) {
        if (!!this.slider) {
          this.slider.detach();
          this.slider.init();
        } else {
          this.attachSlider();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        cell = _this$props.cell,
        uriTransformer = _this$props.uriTransformer,
        linkFromPageId = _this$props.linkFromPageId,
        gridSize = _this$props.gridSize,
        intl = _this$props.intl;
      var cellSize = gridSize * cell.height * 0.8;
      var slides = cell.slides.filter(function (slide) {
        if (!!intl && !!intl.locale) {
          return slide.language_code === intl.locale;
        }
        return !slide.language_code;
      });

      // If there is no slide in this locale, default to the default slides
      if (slides.length === 0) {
        slides = cell.slides.filter(function (slide) {
          return !slide.language_code;
        });
      }
      if (slides.length === 0) {
        return null;
      }
      var slideTags = slides.map(function (slide) {
        var imgTag = /*#__PURE__*/_react.default.createElement("img", {
          style: {
            maxWidth: "100%",
            maxHeight: "100%"
          },
          src: uriTransformer(slide.image_uri),
          alt: "image"
        });
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            height: "".concat(cellSize, "px"),
            width: "".concat(cellSize, "px"),
            lineHeight: "".concat(cellSize, "px")
          },
          key: slide.id,
          className: "slider-item"
        }, !!slide.to_page_id ? linkFromPageId(slide.to_page_id, imgTag) : imgTag);
      });
      return /*#__PURE__*/_react.default.createElement(_Background.default, {
        value: cell,
        uriTransformer: uriTransformer
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "micro-slider",
        id: "slider_".concat(cell.id)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "slider-wrapper"
      }, slideTags)));
    }
  }]);
}(_react.default.PureComponent);
_defineProperty(CarouselCell, "whyDidYouRender", true);
var _default = exports.default = (0, _reactIntl.injectIntl)(CarouselCell);